import { render, staticRenderFns } from "./listaUsuarios.vue?vue&type=template&id=0bbff2c2"
import script from "./listaUsuarios.vue?vue&type=script&lang=js"
export * from "./listaUsuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports